module.exports = __webpack_public_path__ + "img/Stewardship.2d4b9ad5.png";